var lists_default = {
  "fontElementMap": "w848U",
  "orderedlist": "-ILHF",
  "bulletedlist": "ETZrx",
  "listItem": "_35D4j"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
